export const ZENDESK_RETURN_TO_LABEL = 'zendeskReturnTo';
